export default {
  Chapter: 1, // Chương
  KindItem: 2, // Loại khoản
  GroupItem: 3, // Nhóm mục chi
  Item: 4, // mục
  SubItem: 5, // tiểu mục
  SubItemDetail: 6, // tiết tiểu mục
};
